// Vendors
import React from 'react';

// Components
import { SearchBox, MenuSelect } from '../../algolia/components';
import sortAlphaByProperty from '../../lib/utilities/sortAlphaByProperty';

const NationalRebatesSearchFilters = () => (
  <div className="grid grid--gutter grid--between grid--gutter-xs">
    <div className="grid__col-xs-12 grid__col-md-12 grid__col-lg-5">
      <SearchBox
        searchAsYouType={true}
        name="search"
        label="Search National Grants Database..."
        className="u--margin-bottom-0"
      />
    </div>
    <div className="grid__col-xs-12 grid__col-md-12 grid__col-lg-3">
      <div className="grid grid--gutter grid--gutter-xs">
        <div className="grid__col-xs-12">
          <MenuSelect
            name="region"
            attribute="facets.national_grant_working_group"
            limit={100}
            transformItems={(items) => sortAlphaByProperty(items, 'label')}
            emptyOptionLabel="Filter by Working Group"
            className="u--margin-bottom-0"
          />
        </div>
      </div>
    </div>
  </div>
);

export default NationalRebatesSearchFilters;
